import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import sendMessageToNative from './sendMessageToNative';

export default function useFullscreenDispatcher() {
  const {
    isAnyModalOpen,
    isReservableCancelModalOpen,
    isReturnPolicyModalOpen,
    isSoftPullModalOpen
  } = useContext(ModalContext);
  const { isSpinnerImmersive } = useContext(SpinnerContext);
  const isNativeModalOpen =
    isReservableCancelModalOpen ||
    isReturnPolicyModalOpen ||
    isSoftPullModalOpen;
  const isWebModalOpen = isAnyModalOpen && !isNativeModalOpen;
  const isFullscreen = isSpinnerImmersive || isWebModalOpen;

  useSubsequentEffect(() => {
    sendMessageToNative(
      isFullscreen
        ? DispatcherEvent.EnterFullscreen
        : DispatcherEvent.LeaveFullscreen,
      {}
    );
  }, [isFullscreen]);
}
